import { cloneElement, isValidElement } from 'react';
export const asBlocks = (value) => Array.isArray(value) ? value : [];
export const asRecord = (value) => value && typeof value === 'object' && !Array.isArray(value) ? value : {};
export const withBlockKey = (element, block) => isValidElement(element) ? cloneElement(element, { key: block.id }) : element;
